define('lq/main',[
    'domready!',
    'module',
    'require',
    'underscore',
    'jquery',
    'lq/cookie',
    'sentry',
    'lq/safeRedirectUrl'
], function (domready, module, require, _, $, cookie, sentry, safeRedirectUrl) {
    var config = module.config();
    var sentryLogger = null;

    // errors that don't come from Licquid; added to the Sentry SDK's own default list
    var sentryIgnoreErrors = [
        // e-mail link scanners (Outlook Safe Links etc.) built on CefSharp; the SDK only ignores MethodName:simulateEvent
        /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
    ];

    var init = function (initCompleted) {
        if (config.sentryEnvironment) {
            sentry.onLoad(function () {
                sentry.init({
                    dsn: config.sentryDsn,
                    tunnel: config.baseUrl + 'ErrorReporting/Tunnel',
                    environment: config.sentryEnvironment,
                    ignoreErrors: sentryIgnoreErrors,
                    initialScope: {
                        tags: {
                            location: 'front end',
                            tenant: config.tenantName || '',
                            application: config.tenantApplicationName || '',
                            component: config.sentryComponentName || ''
                        },
                        user: {
                            id: config.userId
                        }
                    },
                    beforeSend(event, hint) {
                        event.fingerprint = ['{{ default }}', config.tenantName, config.tenantApplicationName];
                        return event;
                    }
                });

                sentryLogger = sentry;

                initCompleted();
            });
        } else {
            initCompleted();
        }

        $(window).on('unload', function () {
            // without this handle Firefox will not run any javascript on page load after having pressed the 'Back' button of the browser
        });
    };

    var getNotificationsEntryPage = function () {
        return config.notificationsEntryPage;
    };

    var getNotificationIcon = function () {
        return config.notificationIcon;
    };

    var areWebNotificationsEnabled = function () {
        return config.areWebNotificationsEnabled && window.navigator.serviceWorker;
    };
    
    var getFirebaseWPCert = function () {
        return config.firebaseWPCert;
    };

    var getFirebaseAppId = function () {
        return config.firebaseAppId;
    };

    var getFirebaseProjectId = function () {
        return config.firebaseProjectId;
    };

    var getFirebaseSenderId = function () {
        return config.firebaseSenderId;
    };

    var getFirebaseApiKey = function () {
        return config.firebaseApiKey;
    };
    
    var getTenantName = function () {
        return config.tenantName;
    };

    var getTenantApplicationName = function () {
        return config.tenantApplicationName;
    };

    var getBaseUrl = function (path) {
        return config.baseUrl + path;
    };

    var getStylesVersion = function () {
        return config.stylesVersion;
    };

    var getScriptCacheBust = function () {
        return config.scriptCacheBust;
    };

    var getCdnUrl = function (path) {
        return config.cdnUrl + path;
    };

    var getTenantUrl = function (path) {
        return config.tenantUrl + path;
    };

    var getTenantCdnUrl = function (path) {
        return config.tenantCdnUrl + path;
    };

    var getRuntimeUrl = function (path) {
        return config.runtimeUrl + path;
    };

    var getRuntimeBaseUrl = function (path) {
        return config.runtimeBaseUrl + path;
    };

    var getUserId = function () {
        return config.userId;
    };

    var getDesignerId = function () {
        return config.designerId;
    };

    var getDesignerUrl = function (path) {
        return config.designerUrl + path;
    };

    var getPortalUrl = function (path) {
        return config.portalUrl + path;
    };
    var getDesignerBaseUrl = function (path) {
        return config.designerBaseUrl + path;
    };

    var getTenantUploads = function (path) {
        return config.tenantUploads + path;
    };

    var getFrontEndUrl = function (path) {
        return config.frontEndUrl + path;
    };

    var getNameOfComponent = function () {
        return config.componentName;
    };

    var getSentryLogger = function () {
        return sentryLogger;
    };

    var setSentryLogger = function (instance) {
        sentryLogger = instance;
    };

    var getOrigin = function () {
        if (window.location.origin)
            return window.location.origin + '/';
        return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    };

    var getFullUrl = function (pathFromRoot) {
        if (pathFromRoot && pathFromRoot.indexOf('/') === 0)
            pathFromRoot = pathFromRoot.slice(1);
        return getOrigin() + pathFromRoot;
    };

    var getLanguageIsoCode = function () {
        return config.languageISOCode;
    };

    var inMockMode = false;
    var inForcedDevMode = new URLSearchParams(window.location.search).get('dev');

    var setIsInMockMode = function (value) { inMockMode = value; };
    var isInMockMode = function () { return inMockMode; };
    var isInForcedDevMode = function () { return inMockMode && inForcedDevMode; };

    var getCqRouterUrl = function (altName) {
        return config.cqRouterUrl.replace("{{{ApplicationName}}}", altName || "CQ");
    }

    // yes, we need to know this
    var browserMatchesChrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
    var isChrome = function () {
        return browserMatchesChrome;
    };

    var isScriptDebuggingEnabled = function () {
        return config.scriptDebuggingEnabled;
    };

    return {
        init: init,
        safeRedirectUrl: safeRedirectUrl,
        getNotificationIcon: getNotificationIcon,
        areWebNotificationsEnabled: areWebNotificationsEnabled,
        getFirebaseApiKey: getFirebaseApiKey,
        getFirebaseAppId: getFirebaseAppId,
        getFirebaseProjectId: getFirebaseProjectId,
        getFirebaseSenderId: getFirebaseSenderId,
        getFirebaseWPCert: getFirebaseWPCert,
        getNotificationsEntryPage: getNotificationsEntryPage,
        isScriptDebuggingEnabled: isScriptDebuggingEnabled,
        getStylesVersion: getStylesVersion,
        getScriptCacheBust: getScriptCacheBust,
        getTenantName: getTenantName,
        getTenantApplicationName: getTenantApplicationName,
        getBaseUrl: getBaseUrl,
        getCdnUrl: getCdnUrl,
        getTenantUrl: getTenantUrl,
        getTenantCdnUrl: getTenantCdnUrl,
        getRuntimeUrl: getRuntimeUrl,
        getRuntimeBaseUrl: getRuntimeBaseUrl,
        getUserId: getUserId,
        getDesignerId: getDesignerId,
        getDesignerUrl: getDesignerUrl,
        getDesignerBaseUrl: getDesignerBaseUrl,
        getTenantUploads: getTenantUploads,
        getFrontEndUrl: getFrontEndUrl,
        getPortalUrl: getPortalUrl,
        getFullUrl: getFullUrl,
        getNameOfComponent: getNameOfComponent,
        getSentryLogger: getSentryLogger,
        getLanguageIsoCode: getLanguageIsoCode,
        getCqRouterUrl: getCqRouterUrl,
        setIsInMockMode: setIsInMockMode,
        isInMockMode: isInMockMode,
        isInForcedDevMode: isInForcedDevMode,
        setSentryLogger: setSentryLogger,
        sentryIgnoreErrors: sentryIgnoreErrors,
        browser: {
            isChrome: isChrome
        }
    };
});

define('lq', ['lq/main'], function (main) { return main; });

